import { setCookie, removeCookie, getCookie } from "../../../lib/session";

// simple util so that we can import {setCookie} from "./utils/cookie"; without mobile breaking

// eslint-disable-next-line
export const setCookieUniversal = (key, value, res = undefined) => {
  setCookie(key, value, res);
};

export const deleteCookieUniversal = (key, res = undefined, options = {}) => {
  removeCookie(key, res, options);
};

export const getCookieUniversal = name => getCookie(name);
